import {assetPath} from "./asset-path";

export function getStaticPathIcon(name: string): string {
    return assetPath(`/images/icons/${name}.svg`);
}
